module.exports = __webpack_public_path__ + "static/media/largeGroupTix.8a17d8c4.png";